import { Injectable, inject } from '@angular/core';
import { SessionStorageService } from '@df/browser/storage/session-storage.service';
import { CustomerLoggedGuard } from '@df/session/customer/customer-logged.guard';
import { NSession } from '@df/session/df-session.config';
import { TradeStoreService } from '../../multisite/trade/trade-store.service';
@Injectable({
    providedIn: 'root'
})
export class LocalCustomerLoggedGuard extends CustomerLoggedGuard {
    private config = inject(NSession.OPTIONS);
    private tradeStoreService = inject(TradeStoreService);
    private sessionStorage = inject(SessionStorageService);
    override isCustomerAllowed(): boolean {
        return this.tradeStoreService.isTradeStore() ? this.tradeStoreService.isCommerceAllowed() : super.isCustomerAllowed();
    }

    override onError(): void {
        this.tradeStoreService.isTradeStore() && this.sessionStorage.set('tradeStorePathOverride', this.router.url);
        this.router.navigate([this.config.onCustomerLoggedGuardErrorUrl]);
    }
}
